// @ts-nocheck
class EpQuantityUpsell extends HTMLElement {
  connectedCallback() {
    this._config = this._parseConfig();
    this._selectedQty = 20;
    this._slotSelections = this._initSelections();
    this._bindEvents();
    this._applyCurrentSoldout();
  }

  _applyCurrentSoldout() {
    // Si el producto actual está agotado, desactivar el CTA
    if (this._config.currentAvailable === false) {
      const btn = this.querySelector('.ep-upsell__cta');
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Temporalmente agotado';
      }
    }
  }

  _parseConfig() {
    const script = document.getElementById(`ep-upsell-config-${this.dataset.sectionId}`);
    try { return JSON.parse(script.textContent); }
    catch { return { flavors: [], currentVariantId: '', currentVariantTitle: '', currentVariantImage: '' }; }
  }

  _initSelections() {
    const { currentVariantId, currentVariantTitle, currentVariantImage } = this._config;
    const matchedFlavor = this._config.flavors.find(f => String(f.id) === String(currentVariantId));
    const pre = currentVariantId ? {
      id: currentVariantId,
      name: matchedFlavor ? matchedFlavor.name : currentVariantTitle,
      image: matchedFlavor ? matchedFlavor.image : currentVariantImage,
    } : null;
    return {
      40: [pre, null],
      60: [pre, null, null],
      80: [pre, null, null, null],
    };
  }

  _bindEvents() {
    this.querySelectorAll('.ep-upsell__card').forEach(card => {
      card.addEventListener('click', e => {
        if (e.target.closest('.ep-upsell__slots')) return;
        this._selectCard(card);
      });
    });

    this.querySelector('.ep-upsell__cta').addEventListener('click', () => this._handleCTA());

    document.addEventListener('click', e => {
      if (!e.target.closest('.ep-upsell__slot')) this._closePicker();
    });
  }

  _selectCard(card) {
    this.querySelectorAll('.ep-upsell__card').forEach(c => {
      const selected = c === card;
      c.classList.toggle('ep-upsell__card--selected', selected);
      const slots = c.querySelector('.ep-upsell__slots');
      if (!slots) return;
      if (selected) {
        slots.removeAttribute('hidden');
        this._renderSlots(c);
      } else {
        slots.setAttribute('hidden', '');
      }
    });
    this._closePicker();
    this._selectedQty = parseInt(card.dataset.qty, 10);
    this._updateCTA();
  }

  _renderSlots(card) {
    const qty = parseInt(card.dataset.qty, 10);
    const boxes = parseInt(card.dataset.boxes, 10);
    const slotsEl = card.querySelector('.ep-upsell__slots');
    const selections = this._slotSelections[qty];
    slotsEl.innerHTML = '';

    for (let i = 0; i < boxes; i++) {
      const sel = selections[i];
      const slot = document.createElement('div');
      slot.className = 'ep-upsell__slot';

      const row = document.createElement('div');
      row.className = 'ep-upsell__slot-row';

      const label = document.createElement('span');
      label.className = 'ep-upsell__slot-label';
      label.textContent = `Caja ${i + 1}`;

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = sel ? 'ep-upsell__slot-btn' : 'ep-upsell__slot-btn ep-upsell__slot-btn--empty';

      if (sel?.image) {
        const img = document.createElement('img');
        img.className = 'ep-upsell__slot-thumb';
        img.src = sel.image;
        img.alt = sel.name;
        btn.appendChild(img);
      }

      const nameEl = document.createElement('span');
      nameEl.className = 'ep-upsell__slot-name';
      nameEl.textContent = sel ? sel.name : 'Elegir sabor';
      btn.appendChild(nameEl);

      const chevron = document.createElement('span');
      chevron.className = 'ep-upsell__slot-chevron';
      chevron.textContent = '▾';
      btn.appendChild(chevron);

      btn.addEventListener('click', e => {
        e.stopPropagation();
        this._togglePicker(slot, i, qty);
      });

      row.appendChild(label);
      row.appendChild(btn);
      slot.appendChild(row);
      slotsEl.appendChild(slot);
    }
  }

  _togglePicker(slotEl, slotIndex, qty) {
    const existing = slotEl.querySelector('.ep-upsell__picker');
    if (existing) { existing.remove(); return; }
    this._closePicker();

    const currentSel = this._slotSelections[qty][slotIndex];
    const picker = document.createElement('div');
    picker.className = 'ep-upsell__picker';

    this._config.flavors.filter(f => f.id && f.name).forEach(flavor => {
      const isActive = currentSel && String(currentSel.id) === String(flavor.id);
      const isSoldout = flavor.available === false;
      const opt = document.createElement('button');
      opt.type = 'button';
      const classes = ['ep-upsell__picker-opt'];
      if (isActive) classes.push('ep-upsell__picker-opt--active');
      if (isSoldout) classes.push('ep-upsell__picker-opt--soldout');
      opt.className = classes.join(' ');
      if (isSoldout) opt.disabled = true;

      if (flavor.image) {
        const img = document.createElement('img');
        img.className = 'ep-upsell__picker-opt-img';
        img.src = flavor.image;
        img.alt = flavor.name;
        opt.appendChild(img);
      } else {
        const ph = document.createElement('div');
        ph.className = 'ep-upsell__picker-opt-img';
        opt.appendChild(ph);
      }

      const nameEl = document.createElement('span');
      nameEl.textContent = flavor.name;
      opt.appendChild(nameEl);

      if (isSoldout) {
        const soldoutTag = document.createElement('span');
        soldoutTag.className = 'ep-upsell__picker-soldout-tag';
        soldoutTag.textContent = '· Agotado';
        opt.appendChild(soldoutTag);
      } else {
        const check = document.createElement('span');
        check.className = 'ep-upsell__picker-check';
        check.textContent = '✓';
        opt.appendChild(check);

        opt.addEventListener('click', e => {
          e.stopPropagation();
          this._selectFlavor(slotIndex, qty, flavor);
        });
      }

      picker.appendChild(opt);
    });

    slotEl.appendChild(picker);
  }

  _closePicker() {
    this.querySelectorAll('.ep-upsell__picker').forEach(p => p.remove());
  }

  _selectFlavor(slotIndex, qty, flavor) {
    this._slotSelections[qty][slotIndex] = { id: flavor.id, name: flavor.name, image: flavor.image };
    this._closePicker();
    const card = this.querySelector(`.ep-upsell__card[data-qty="${qty}"]`);
    if (card) this._renderSlots(card);
    this._updateCTA();
  }

  _allSlotsFilled() {
    if (this._selectedQty === 20) return true;
    return (this._slotSelections[this._selectedQty] || []).every(s => s !== null);
  }

  _updateCTA() {
    const btn = this.querySelector('.ep-upsell__cta');
    // Si el producto actual está agotado, mantener desactivado
    if (this._selectedQty === 20 && this._config.currentAvailable === false) {
      btn.textContent = 'Temporalmente agotado';
      btn.disabled = true;
      return;
    }
    if (this._selectedQty === 20 || this._allSlotsFilled()) {
      btn.textContent = 'Agregar al carrito';
      btn.disabled = false;
    } else {
      btn.textContent = 'Elige todos los sabores';
      btn.disabled = true;
    }
  }

  async _handleCTA() {
    if (this._selectedQty === 20) {
      await this._addToCart([{ id: parseInt(this._config.currentVariantId, 10), quantity: 1 }]);
    } else {
      const items = this._slotSelections[this._selectedQty].map(s => ({
        id: parseInt(s.id, 10),
        quantity: 1,
      }));
      await this._addToCart(items);
    }
  }

  async _addToCart(items) {
    const btn = this.querySelector('.ep-upsell__cta');
    const errorEl = this.querySelector('.ep-upsell__error');
    const originalText = btn.textContent;

    btn.textContent = 'Agregando...';
    btn.disabled = true;
    errorEl.classList.remove('ep-upsell__error--visible');

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.description || 'No se pudo agregar al carrito');
      }

      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      if (window.EpCartDrawer) {
        window.EpCartDrawer.open();
      } else {
        window.location.href = '/cart';
      }
      // Sin esto el boton quedaba en "Agregando..." y bloqueado al cerrar el carrito (2026-09-22)
      this._updateCTA();
    } catch (err) {
      errorEl.textContent = err.message;
      errorEl.classList.add('ep-upsell__error--visible');
      btn.disabled = false;
      btn.textContent = originalText;
    }
  }
}

customElements.define('ep-quantity-upsell', EpQuantityUpsell);
